import React from "react";
import styles from "./PrivacyPolicy.module.css";

export default function CancellationPolicy() {
    return (
        <div className={styles.privacyContainer}>
            <h1 style={{ textAlign: "center" }}>Cancellation & Refund Policy</h1>

            <h4>Cancellation Window & Deductions</h4>
            <p>
                15 or more days before Check-in Date — 20% deduction from the total booking amount.
            </p>
            <p>
                7 to 14 days before Check-in Date — 30% deduction from the total booking amount.
            </p>
            <p>
                2 to 6 days before Check-in Date — 50% deduction from the total booking amount.
            </p>
            <p>
                Less than 2 days before Check-in Date — No cancellation allowed (100% deduction).
            </p>

            <h4>Refund Process</h4>
            <p>
                Refunds (if applicable) will be processed to the original payment method used during
                booking. The refund timeline may take 7–10 working days depending on the bank or
                payment gateway.
            </p>

            <h4>Non-Refundable Conditions</h4>
            <p>
                No refund will be issued for cancellations made within 2 days of check-in Date.
            </p>
            <p>
                No refund will be issued for no-shows or early check-outs.
            </p>

            <h4>Contact Information</h4>
            <p>
                Jharkhand Tourism Development Corporation Ltd. (JTDCL) <br />
                Email: jtdcltd@gmail.com <br />
                Phone: +91 9102403884
            </p>
        </div>
    );
}
